<template>
  <el-checkbox v-model="localModel" v-on="$listeners">
    <slot />
  </el-checkbox>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  model: {
    prop: 'value',
    event: 'update:value'
  },
  props: {
    value: { type: Boolean, default: false },
  },
  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      }
    }
  }
}
</script>
